import { connect } from 'react-redux';

import { WixConnect } from 'shared/utils/wix-connect';

import { canShowMainItemTitle, canShowMainItemPublisher } from 'shared/selectors/app-settings';

import OverlayMemberOnlyBase from 'widget/components/player-overlay/_base-member-only-overlay';
import Title from '../partials/title';
import ResizedImage from 'shared/components/resized-image/resized-image';

import styles from './member-only.styl';


class OverlayMemberOnlyMobileBase extends OverlayMemberOnlyBase {


  renderTitle() {
    return (
      <div className={styles.title}
           id="overlay-heading"
           role="heading"
           aria-level="1"
           aria-label={this.titleText}>
        <span className={styles['title-text']}
              aria-hidden="true">
          <Title text={this.titleText} />
        </span>
      </div>
    );
  }

  get buttons() {
    return (
      <div styleName="buttons">
        {this.playButton}
      </div>
    );
  }

  renderPublisher() {
    const { videoItem: { publisher } } = this.props;

    return (
      <div className={styles.publisher}>
        <span className={styles['publisher-text']}>
          {publisher}
        </span>
      </div>
    );
  }

  render() {
    const { className, width, height } = this.props;
    const styles = this.getOpacityStyles();

    return (
      <div className={styles.wrapper}
           role="presentation">
        <ResizedImage src={this.coverUrl}
                      role="presentation"
                      width={width}
                      height={height}>
          <div style={styles}
               styleName="overlay"
               className={className}
               role="presentation">
            {this.shouldShowTitle && this.renderTitle()}
            {this.shouldShowPublisher && this.renderPublisher()}
            {this.buttons}
          </div>
        </ResizedImage>
      </div>
    );
  }
}
//is publisher really never shown ?

@WixConnect(styles)
export class OverlayMemberOnlyMobileNoTitle extends OverlayMemberOnlyMobileBase {

  static displayName = 'OverlayMemberOnlyMobileNoTitle';

  get buttonStyleName() {
    return 'button simple-play-button';
  }

  get shouldShowTitle() {
    return false;
  }

  get shouldShowPublisher() {
    return false;
  }
}


@connect(state => ({
  canShowMainItemTitle: canShowMainItemTitle(state),
  canShowMainItemPublisher: canShowMainItemPublisher(state),
}))
@WixConnect(styles)
export default class OverlayMemberOnlyMobile extends OverlayMemberOnlyMobileBase {
  static displayName = 'OverlayMemberOnlyMobile';

  get buttonStyleName() {
    return 'button simple-play-button';
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/mobile/member-only.js